import React from 'react'
import { makeIcon } from '../icons'

export interface DividerDecorativeProps {
  color?: string
  className?: string
}

export const DividerDecorative: React.FC<DividerDecorativeProps> = ({ color, className }) => {
  const classes = ['divider-decorative', className].filter(Boolean).join(' ')

  return (
    <div
      className={classes}
      style={color ? { color } : undefined}
    >
      <span className="divider-decorative__line" />
      {makeIcon('star-ai', '16px')}
      <span className="divider-decorative__line" />
    </div>
  )
}
